export const addMarker = ({
  min,
  max,
  rowIndex,
  timestamp,
  x,
  y,
  questionId,
}) => ({
  type: 'ADD_MARKER',
  max,
  questionId,
  rowIndex,
  timestamp,
  x,
  y,
});

export const removeMarker = (rowIndex, timestamp, questionId) => ({
  type: 'REMOVE_MARKER',
  questionId,
  rowIndex,
  timestamp,
});

export const selectMarker = (timestamp, rowIndex, questionId) => ({
  type: 'SELECT_MARKER',
  questionId,
  rowIndex,
  timestamp,
});

export const deselect = questionId => ({ type: 'DESELECT', questionId });

export const updateNote = (timestamp, value, questionId) => ({
  type: 'UPDATE_NOTE',
  questionId,
  timestamp,
  value,
});

export const selectRow = (rowIndex, questionId) => ({
  type: 'SELECT_ROW',
  questionId,
  rowIndex,
});

export const selectNextRow = questionId => ({
  type: 'SELECT_NEXT_ROW',
  questionId,
});

export const setDomain = (dimensions, questionId) => ({
  type: 'SET_DOMAIN',
  questionId,
  ...dimensions,
});

export const beginCountdown = questionId => ({
  type: 'BEGIN_COUNTDOWN',
  questionId,
});

export const count = (cb, timeout, questionId) => ({
  type: 'COUNT',
  cb,
  questionId,
  timeout,
});

export const open = questionId => ({ type: 'OPEN', questionId });

export const close = questionId => ({ type: 'CLOSE', questionId });
